import React, {useEffect, useRef} from 'react';
import {Mesh, Vector3} from 'three';
import {LAYERS} from 'lib';

interface IARModelShadowPlaneProps {
  meshSize: Vector3;
}

const ARModelShadowPlane = ({meshSize}: IARModelShadowPlaneProps) => {
  const shadowRef = useRef<Mesh>(null);
  useEffect(() => {
    if (shadowRef.current) {
      shadowRef.current.layers.set(LAYERS.SHADOW);
    }
  }, []);
  return (
    <mesh key="shadow" ref={shadowRef} receiveShadow scale={[meshSize.x * 1.25, meshSize.z * 1.25, 0.001]} rotation={[-Math.PI / 2, 0, 0]}>
      <shadowMaterial opacity={0.1} />
      <planeGeometry />
    </mesh>
  );
};

export default React.memo(ARModelShadowPlane);
